import { GoShieldLock } from "react-icons/go";
import { LuShield } from "react-icons/lu";
import { Badge, Card, CardBody, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";

function AccessControl() {
  const { t } = useTranslation();
  const items = [
    { icon: <GoShieldLock size={22} className="text-muted" />, title: t('security.allowedIPs'),           desc: t('security.allowedIPsDesc')           },
    { icon: <LuShield     size={22} className="text-muted" />, title: t('security.restrictedCountries'),  desc: t('security.restrictedCountriesDesc')  },
  ];
  return(
    <TabPane tabId="access-control">
      {items.map((item, i) => (
        <Card key={i} className="mb-3">
          <CardBody className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3">
              {item.icon}
              <div>
                <p className="fw-medium mb-0">{item.title}</p>
                <small className="text-muted">{item.desc}</small>
              </div>
            </div>
            <Badge color="light" className="text-secondary border">{t('common.comingSoon')}</Badge>
          </CardBody>
        </Card>
      ))}
    </TabPane>
  );
}

export default AccessControl;
